import { createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../config'
import { getIDToken } from '../utils/AuthUtil'
import { File } from '../models/Organization'
import { NotificationType } from '../models/Notification'
import { RootState } from '../store'

export const sendEmailAsync = createAsyncThunk(
  'notification/sendEmail',
  async (
    payload: { file: File; url: string; notificationType: NotificationType },
    { dispatch, getState },
  ) => {
    const state = getState() as RootState
    const project = state.organization.projects.find(
      (project) => project.id === payload.file.project_id,
    )
    const body = {
      fileId: payload.file.id,
      fileUrl: payload.url,
      projectName: project?.name,
      templateName: payload.notificationType,
    }
    return fetch(`${BASE_URL}/api/notification/sendEmail`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }).catch((error) =>
      console.error('Error during creating notification: ', error),
    )
  },
)
